module.exports = __webpack_public_path__ + "static/Riley_Welch_92Social_Owner-2b9542122e1c3cc4c733bd12439c45c4.jpg";